"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getContrastRatio = _interopRequireDefault(require("get-contrast-ratio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Calculate wich color in a array of colors gives the highest contrast to another color.
 *
 * @param background string A string that can be parsed as a CSS color
 * @param colors array An array of strings that can be parsed to CSS colors
 * @return string The color from colors that has the highest contrast to background
 */
var getBestContrastColor = function getBestContrastColor(background) {
  var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return colors.reduce(function (acc, color) {
    return (0, _getContrastRatio["default"])(background, color) > (0, _getContrastRatio["default"])(background, acc) ? color : acc;
  });
};

var _default = getBestContrastColor;
exports["default"] = _default;